export default __webpack_public_path__ + "static/media/iconPhone.82106027.svg";